import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import _ from 'lodash';

import styled from 'styled-components';


import BookElement from 'app/api/bookElement';

import Words from 'app/components/BookElements/Words';
import Picture from 'app/components/BookElements/Picture';
import MediaClip from 'app/components/BookElements/MediaClip';
import Thumbnail from 'app/components/BookElements/Thumbnail';

import List from 'app/components/BookElements/List';

import {
  Box,
  Text,
  Accordion as GrommetAccordion,
  AccordionPanel as GrommetAccordionPanel,
} from 'grommet';

import 'video-react/dist/video-react.css';

import LayoutEngine from 'app/api/layoutEngine';

import ScrollIntoViewIfNeeded from 'react-scroll-into-view-if-needed';
const scrollIntoViewOptions = { behavior: 'instant', block: 'start' };

const Container = styled.div`
  max-width: 600px;
  max-height: 800px;
  margin: 32px auto;
`;

const AccordionBookElement = styled(GrommetAccordion)`
  width: 100%;
  max-width: 600px;
  overflow: hidden;
`;

const AccordionPanel = styled(GrommetAccordionPanel)`
  height: 40px;
`;

const AccordionContent = styled(Box)`
  height: 350px;
  max-width: 600px;
  overflow-y: auto;
  box-shadow: 0px 2px 4px rgba(100, 100, 100, 0.5) inset;
  padding: 0 6px;
`;

function compileLayoutData(path, content, panel, index) {
  let data;
  if (_.isString(content)) { 
    data = { type: 'words', path: [...path, 'panels', panel, index] };
  } else {
    let type = _.keys(content)[0];
    type = type
      .replace(new RegExp(content[type].prefix, 'i'), '')
      .replace(new RegExp(content[type].postfix, 'i'), '');
    type = _.trim(type);
    data = {
      type,
      path: [...path, 'panels', panel, index, _.keys(content)[0]],
    };
  }
 
  return data;
}

const layoutEngine = new LayoutEngine({
  words: Words,
  picture: Picture,
  thumbnail: Thumbnail,
  'sound clip': MediaClip,
  'video clip': MediaClip,
  list: List,
});
class Accordion extends React.Component {
  render() {
    const { AppState, path, content } = this.props;
    return (
      <Container>
        <ScrollIntoViewIfNeeded
          options={scrollIntoViewOptions}
          active={_.isEqual(path, AppState.selectedSectionItem)}
        >
          <Box align="center">
            <AccordionBookElement aria-label="accordion" animate={false}>
              {_.map(content.panels, (panel, label) => (
                <AccordionPanel key={label} background="light-4" label={label}>
                  <AccordionContent flex="grow">
                    <div>
                      {_.map(panel, (entry, index) =>
                        layoutEngine.render(
                          compileLayoutData(path, entry, label, index)
                        )
                      )}
                      
                    </div>
                  </AccordionContent>
                </AccordionPanel>
              ))}
            </AccordionBookElement>
            <Text weight="bold" textAlign="center">
              {BookElement.extractTitleFromPath(path)} — {content.caption}
            </Text>
          </Box>
        </ScrollIntoViewIfNeeded>
      </Container>
    );
  }
}

Accordion.propTypes = {
  /**
   * content path
   */
  path: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ).isRequired,
  /**
   * source, caption, panels, prefix, postfix,
   */
  content: PropTypes.shape({
    caption: PropTypes.string.isRequired,
    prefix: PropTypes.string,
    postfix: PropTypes.string,
    panels: PropTypes.objectOf(
      PropTypes.arrayOf(
        PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.shape({
            picture: PropTypes.shape({
              source: PropTypes.string.isRequired,
              caption: PropTypes.string.isRequired,
            }),
            'video clip': PropTypes.shape({
              source: PropTypes.string.isRequired,
              poster: PropTypes.string.isRequired,
              caption: PropTypes.string.isRequired,
            }),
            'sound clip': PropTypes.shape({
              source: PropTypes.string.isRequired,
              poster: PropTypes.string.isRequired,
              caption: PropTypes.string.isRequired,
            }),
          }),
        ]).isRequired
      ).isRequired
    ).isRequired,
  }),
};
Accordion.defaultProps = {
  content: {},
};

const Component = inject('AppState')(observer(Accordion));
Component.displayName = 'Accordion';
export const AccordionComponent = Accordion;
export default Component;



// WEBPACK FOOTER //
// ./src/app/components/BookElements/Accordion.js